// Dependencies
require("webstrap/type");
require("grid");
require("element/rich-text");

// Styles
require("./news-list.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/news-list/index.js
 ** module id = 109
 ** module chunks = 0 1
 **/